class VirtualSizer extends HTMLElement {
  constructor() {
    super();

    this.formSettings = {
      heightInMin: 52,
      heightInMax: 82,
      weightLbsMin: 71,
      weightLbsMax: 422,
      ageMin: 13,
      ageMax: 89,
      braSizes: {
        us: {
          band: ['28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
        },
        au: {
          band: ['6', '8', '10', '12', '14', '16', '18', '20', '22', '24', '26', '28', '30', '32', '34'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K'],
        },
        gb: {
          band: ['28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K'],
        },
        eu: {
          band: ['60', '65', '70', '75', '80', '85', '90', '95', '100', '105', '110', '115', '120', '125', '130'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'E', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
        },
      },
    };

    this.formSettings.heighttFtMin = Math.floor(this.formSettings.heightInMin / 12);
    this.formSettings.heighttFtMax = Math.floor(this.formSettings.heightInMax / 12);

    this.formSettings.weightKgsMin = Math.ceil(this.formSettings.weightLbsMin * 0.45);
    this.formSettings.weightKgsMax = Math.floor(this.formSettings.weightLbsMax * 0.45);

    this.setAnonId();
  }

  setAnonId() {
    const sessionStorageKey = 'bold_anon_id';
    const bmAnonId =  getCookie("bm");
    if(bmAnonId && bmAnonId.length > 0){
      this.anon_id = bmAnonId;
    }
    else {
      this.anon_id = sessionStorage.getItem(sessionStorageKey)
    }

    if (!this.anon_id) {
      this.anon_id = Math.round(Math.random() * 100000000000);
      sessionStorage.setItem(sessionStorageKey, this.anon_id);
    }
  }

  connectedCallback() {
    this.goodRecs = null;
    this.modal = this.closest('modal-dialog');
    this.form = this.querySelector('form');
    this.sizeToggles = this.querySelectorAll('[name="size_toggle"]');
    this.showCmEls = this.querySelectorAll('[data-cm]');
    this.showInchEls = this.querySelectorAll('[data-inch]');
    this.screenButtons = this.querySelectorAll('[data-switch-screen]');

    this.inputs = {
      heighttM: this.querySelector('[name="height_m"]'),
      heightCm: this.querySelector('[name="height_cm"]'),
      heightFt: this.querySelector('[name="height_ft"]'),
      heightIn: this.querySelector('[name="height_in"]'),
      weightLbs: this.querySelector('[name="weight_lb"]'),
      weightKgs: this.querySelector('[name="weight_kg"]'),
      age: this.querySelector('[name="age"]'),
      braBand: this.querySelector('[name="bra_band"]'),
      braCup: this.querySelector('[name="bra_cup"]'),
      desired_garment_type: this.querySelector('[name="desired_garment_type"]'),
    };

    this.results = {
      bestSizeEl: this.querySelector('[data-best-size]'),
      bestFit: this.querySelector('[data-best-fit]'),
      fitUpper: this.querySelector('[data-fit="upper"]'),
      fitLower: this.querySelector('[data-fit="lower"]'),
      hipFits: this.querySelectorAll('[data-fit-hip]'),
      waistFits: this.querySelectorAll('[data-fit-waist]'),
      chestFits: this.querySelectorAll('[data-fit-chest]'),
      goodMatches: this.querySelector('[data-good-matches]'),
      dimensions: this.querySelector('[data-dimensions]'),
      customer: this.querySelector('[data-customer]'),
      acceptButtons: this.querySelectorAll('[data-accept-button]'),
      otherSizesEl: this.querySelector('[data-other-sizes]'),
    };

    this.buttons = {
      findRecSizeBtns: document.querySelectorAll("button[data-vsizer-btn]"),
    };

    this.populateForm();
    this.addEventHandlers();
    this.setSizeUnit();
    this.selectPreferedSize();
  }

  selectPreferedSize(){
    try{
      const localStorageVal = window.localStorage.getItem(SIZE_PREFS_KEY);
      const sizePrefObj =  localStorageVal ? JSON.parse(localStorageVal) : {};
      const prefSize = sizePrefObj[this.inputs.desired_garment_type.value];
      if(prefSize && prefSize.length > 0){
        if(!window.location.href.includes("?variant=")){
          const variantRadio = document.querySelector(`input[type="radio"][name="SIZE"][value="${prefSize}"]`);
          variantRadio?.click();
        }
        this.buttons.findRecSizeBtns.forEach(btn => btn.innerText = window.themeStrings.recommendedSizeFilled + " " + prefSize);
      }
    }
    catch(e){
      console.error(e);
    }
  }

  disconnectedCallback() {}

  addEventHandlers() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    for (const acceptButton of this.results.acceptButtons) {
      acceptButton.addEventListener('click', this.onAcceptClick.bind(this));
    }

    for (const sizeToggle of this.sizeToggles) {
      sizeToggle.addEventListener('click', this.onSizeToggleClick.bind(this));
    }

    for (const button of this.screenButtons) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.switchScreen(event.target.dataset.switchScreen);
      });
    }

    this.inputs.heightFt.addEventListener('change', (event) => {
      let maxInch = 11;
      if (parseInt(this.inputs.heightFt.value) === this.formSettings.heighttFtMax) {
        maxInch = this.formSettings.heightInMax % 12;
        console.log('maxInch', maxInch);
      }
      this.inputs.heightIn.setAttribute('max', maxInch);
    });
  }

  onAcceptClick(event) {
    this.modal?.hide();
    this.switchScreen('form');
    if (!this.activeSizeRec) return;
    this.storeSizePreference(this.activeSizeRec);
    const variantRadio = document.querySelector(`input[type="radio"][name="SIZE"][value="${this.activeSizeRec}"]`);
    variantRadio?.click();
    variantRadio?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.buttons.findRecSizeBtns.forEach(btn => btn.innerText = window.themeStrings.recommendedSizeFilled + " " + this.activeSizeRec);

  }

  storeSizePreference(preferedRecSize){
    try{
      const localStorageVal = window.localStorage.getItem(SIZE_PREFS_KEY);
      const sizePrefObj =  localStorageVal ? JSON.parse(localStorageVal) : {};
      sizePrefObj[this.inputs.desired_garment_type.value] = preferedRecSize;
      window.localStorage.setItem(SIZE_PREFS_KEY, JSON.stringify(sizePrefObj));
    }
    catch(e){
      console.error(e);
    }
  }



  populateForm() {
    const locale = this.form.locale.value;
    this.populateSelect(this.inputs.braBand, this.formSettings.braSizes[locale].band);
    this.populateSelect(this.inputs.braCup, this.formSettings.braSizes[locale].cup);
  }

  populateSelect(select, valsArr, min, max) {
    if (!select || select.nodeName !== 'SELECT') return;
    let markup = ``;
    if (min && max) {
      for (let i = min; i < max + 1; i++) {
        markup += this.getOptionMarkup(i);
      }
    } else if (valsArr) {
      for (const val of valsArr) {
        markup += this.getOptionMarkup(val);
      }
    }
    if (select.dataset.placeholder !== undefined) {
      markup = `<option disabled selected value="">${select.dataset.placeholder}</option>${markup}`;
    }
    select.innerHTML = markup;
  }

  getOptionMarkup(val, label) {
    return `<option value="${val}">${label ? label : val}</option>`;
  }

  setSizeUnit(val) {
    if (!val) {
      val = this.querySelector('[name="size_toggle"].is-active').value;
    }

    const isCm = !!(val === 'cm');

    this.showCmEls.forEach((x) => {
      x.hidden = !isCm;
      x.querySelectorAll('input, select').forEach((y) => {
        y.disabled = !isCm;
        y.value = '';
      });
    });

    this.showInchEls.forEach((x) => {
      x.hidden = isCm;
      x.querySelectorAll('input, select').forEach((y) => {
        y.disabled = isCm;
        y.value = '';
      });
    });
  }

  onSizeToggleClick(event) {
    event.preventDefault();

    const thisToggle = event.target;

    for (const sizeToggle of this.sizeToggles) {
      sizeToggle.classList.remove('is-active');
    }

    thisToggle.classList.add('is-active');
    this.setSizeUnit(thisToggle.value);
  }

  onFormSubmit(event) {
    event.preventDefault();

    const form = event.target;

    if (!form.checkValidity()) {
      return;
    }

    // if we have metric units, convert to imperial for API call
    let heightIn;
    let weightLb;

    if (form.height_ft.value && form.height_in.value) {
      heightIn = parseInt(form.height_ft.value) * 12 + parseInt(form.height_in.value);
    } else if (form.height_cm.value) {
      heightIn = Math.round(parseInt(form.height_cm.value) * 0.3937007874); // cm > inch
    }

    if (form.weight_lb.value) {
      weightLb = parseInt(form.weight_lb.value);
    } else if (form.weight_kg.value) {
      weightLb = Math.round(parseInt(form.weight_kg.value) * 2.2046226218); // lb > kg
    }

    const data = {
      product_id: form.product_id.value,
      desired_garment_type: form.desired_garment_type.value,
      height_in: heightIn,
      weight_lb: weightLb,
      age: parseInt(form.age.value),
      locale: form.locale.value,
    };

    if (form.bra_band && form.bra_cup) {
      data.bra_band = form.bra_band.value;
      data.bra_cup = form.bra_cup.value;
    }

    this.makeAPICall(data);
  }

  makeAPICall(data) {
    const params = new URLSearchParams({
      client_id: 'meshki',
      user_key: '7621d5ba3d5ba47e9583290641dffb95fffb96025e79f70b',
      desired_brand: 'meshki',
      age: data.age,
      height: data.height_in,
      weight: data.weight_lb,
      anon_id: this.anon_id || 'TEST',
      product_id: data.product_id,
      desired_garment_type: data.desired_garment_type,
      locale: data.locale,
    });

    if (data.bra_band && data.bra_cup) {
      params.append('bra_size', `${data.bra_band}${data.bra_cup}`);
    }

    const endpoint = `https://api.boldmetrics.io/virtualsizer/get?${params.toString()}`;

    console.log('Bold API call', Object.fromEntries(params), endpoint);

    // DUMMY ENDPOINT:
    // const endpoint = 'https://api.boldmetrics.io/virtualsizer/get?client_id=meshki&user_key=7621d5ba3d5ba47e9583290641dffb95fffb96025e79f70b&desired_brand=meshki&age=30&bra_size=32C&height=65&weight=150&anon_id=TEST&desired_garment_type=womens_generic_tops_alpha&locale=us';

    this.switchScreen('loading');

    fetch(endpoint)
      .then((response) => response.json())
      .then((response) => {
        console.log('response', response);
        if (response.code !== 200) {
          return console.error(response);
        }
        this.showResults(response);
        this.sendProductUpdateEvent(response);
      });
  }

  toTitleCase(str) {
    if (!str) return '';
    return str.split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  populateLabels(fit_description) {
    // toggle upper/lower screen vis
    if (fit_description.chest_circum) {
      this.results.fitLower.hidden = true;
      this.results.fitUpper.hidden = false;
    } else {
      this.results.fitLower.hidden = false;
      this.results.fitUpper.hidden = true;
    }
    for (const label of this.results.chestFits) {
      label.innerHTML = this.toTitleCase(fit_description.chest_circum);
    }
    for (const label of this.results.hipFits) {
      label.innerHTML = this.toTitleCase(fit_description.hip_circum);
    }
    for (const label of this.results.waistFits) {
      label.innerHTML = this.toTitleCase(fit_description.waist_circum_stomach || fit_description.waist_circum_natural || fit_description.waist_circum_preferred);
    }
  }

  showResults(data) {
    this.goodRecs = data.size_recommendations.good_matches;
    console.log('good_matches', this.goodRecs);
    
    if (!this.goodRecs) {
      return this.switchScreen('no-results');
    }

    const bestRec = this.goodRecs[0];

    this.activeSizeRec = bestRec.garment.size;
    this.results.bestSizeEl.innerHTML = bestRec.garment.size;
    this.populateLabels(bestRec.fit_description);

    let markup = '';

    //sort
    try {
      const sizeOrder = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL"];
      
      this.goodRecs.sort(function(a, b) {
        const sizeA = a.garment.size;
        const sizeB = b.garment.size;


        const isNumericA = !isNaN(sizeA);
        const isNumericB = !isNaN(sizeB);

        if (isNumericA && isNumericB) {
          return Number(sizeA) - Number(sizeB);
        } else if (!isNumericA && !isNumericB) {
          return sizeOrder.indexOf(sizeA) - sizeOrder.indexOf(sizeB);
        } else {
          return isNumericA ? -1 : 1;
        }
      });
    } catch(e) {
      console.error(e);
    }
    //end sort

    this.goodRecs.forEach((match, i) => {
      // check if recommended size is actually available as product variant, skip if not
      const atcSizeEl = document.querySelector(`input[type="radio"][name="SIZE"][value="${match.garment.size}"]`);
      if (!atcSizeEl) return;
      const stateClass = (match.garment.size === bestRec.garment.size) ? ' is-active' : '';
      markup += `<li><button class="pill-button pill-button--large${stateClass}">${match.garment.size}</button></li>`;
    })
    this.results.otherSizesEl.innerHTML = markup;

    // handle size button clicks
    const sizeButtons = this.results.otherSizesEl.querySelectorAll('button');
    for (const button of sizeButtons) {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const buttonEl = event.target;
        const activeSize = buttonEl.innerText;
        const rec = this.goodRecs.find(x => x.garment.size === activeSize);

        // update ATC target
        this.activeSizeRec = activeSize;

        // update fit labels
        this.populateLabels(rec.fit_description);

        // update button active states
        for (const x of sizeButtons) {
          x.classList.remove('is-active');  
        }
        buttonEl.classList.add('is-active');
      })
    }

    this.switchScreen('results');
  }

  switchScreen(name) {
    const targetScreen = this.querySelector(`[data-sizer-screen="${name}"]`);
    if (!targetScreen) return;
    this.screens = this.querySelectorAll('[data-sizer-screen]');
    for (const screen of this.screens) {
      screen.hidden = true;
    }
    targetScreen.hidden = false;
  }

  sendProductUpdateEvent(response) {
    document.dispatchEvent(
        new CustomEvent('bmi-recommendation-sent', {
            bubbles: true,
            detail: {
                api: response,
            },
        })
    )
  }
}

customElements.define('virtual-sizer', VirtualSizer);
